import { defineComponent as _defineComponent } from 'vue'

// $attrs are passed to UiModal explicitly, don't duplicate them on the root
const __default__ = {
  inheritAttrs: false,
};

interface Props {
  id?: string;
}
interface Emits {
  (e: 'close'): void;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'VideoPlayerModal',
  props: {
    id: { default: '' }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {





const onChangeValue = (value: any) => {
  if (!value) emit('close');
};

return { __sfc: true,emit, onChangeValue }
}

})